import { cva } from "class-variance-authority";

export const swiperButtonVariants = cva(
  "rounded-full pointer-events-auto transition-opacity duration-300",
  {
    variants: {
      size: {
        xs: "w-6 h-6",
        sm: "w-8 h-8",
        default: "",
        lg: "w-11 h-11",
      },
      visibility: {
        visible: "opacity-100",
        hidden: "opacity-0 pointer-events-none",
      },
    },
    defaultVariants: {
      size: "default",
      visibility: "visible",
    },
  }
);
